import React from 'react'
import { List } from 'antd'
import Image from 'next/image'
import { CustomText } from 'src/components'
import { useTranslation } from 'next-i18next'
import { RecentPurchase } from 'src/core/models'
import { useAppSelector, useWindowSize } from 'src/app/hooks'
import styles from './ProjectDetailsRecentPurchases.module.scss'
import { currencyListSelector, selectCurrencyToken } from 'src/features'
import { getFormatedPrice, getSmallTransformedDate } from 'src/core/helpers'
import ProjectDetailsCollapse from '../ProjectDetailsCollapse/ProjectDetailsCollapse'

const ProjectDetailsRecentPurchases: React.FC<{ purchases: RecentPurchase[] }> = ({ purchases }) => {
  const { t } = useTranslation()
  const currencyList = useAppSelector(currencyListSelector)
  const selectedCurrency = useAppSelector(selectCurrencyToken)
  const { isMobile } = useWindowSize()

  const getCurrencyCode = (symbol: string) => {
    const currencyCode = currencyList.find(c => c.symbol === symbol)?.code
    if (selectedCurrency === 'CLP' && symbol === '$') return 'CLP'
    return currencyCode
  }
  const userType = (type: 'company' | 'individual') => {
    return {
      company: t('footer.company'),
      individual: t('Person')
    }[type]
  }

  const formatString = (string: string) => string.replace(/\d+/g, '<sub>$&</sub>')

  return (
    <ProjectDetailsCollapse label={<CustomText label={t('Projects.RecentPurchases')} strong />}>
      <List dataSource={purchases}
        renderItem={(purchase: RecentPurchase) => (
          <List.Item>
            <React.Fragment>
              {/* Image Content */}
              <div className={styles.columnPosition}>
                <CustomText
                  strong
                  label={userType(purchase.user_type)}
                />  <br />
                <Image
                  src={purchase.country_flag}
                  loader={() => purchase.country_flag}
                  unoptimized={true}
                  alt={`${purchase.country_code}-flag`}
                  height={15}
                  width={20}
                />
                <CustomText
                  label={`${purchase.country_code}`}
                  className={styles.countryCode}
                />
              </div>

              {/* Purchase Amount Details */}
              <div>
                <CustomText
                  label={`${getFormatedPrice(purchase.amount_value, getCurrencyCode(purchase.currency))}`}
                  className={styles.amount}
                />  <br />
                <div className='flex'>
                  <CustomText
                    label={`${purchase.amount.toFixed(2)}`}
                  />&nbsp;
                  <div dangerouslySetInnerHTML={{ __html: formatString(purchase.unit_of_measurement) }} />
                </div>
              </div>

              {/* Purchase Date */}
              <CustomText
                label={`${getSmallTransformedDate(purchase.created)}`}
                type='secondary'
                className={!isMobile && 'mr-5'}
              />
            </React.Fragment>
          </List.Item>
        )}
      />
    </ProjectDetailsCollapse>
  )
}

export default ProjectDetailsRecentPurchases
